
export default {
  selectKey:'Home',
  regExp: {
    postCode: /^\d{6}$/, // 邮编验证
    // pass: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[^]{8,20}$/, // 8-20位包含字母大小写+数字密码
    pass: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, // 8-20位包含字母+数字密码
    url: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // 网址验证
    phone: /^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/, // 手机号码验证
    email: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, // 邮箱验证
    blank: /^([0-9]{1})(\d{8}|\d{9}|\d{10}|\d{11}|\d{12}|\d{13}|\d{14}|\d{15}|\d{16}|\d{17}|\d{18}|\d{19})$/, // 银行
    IdCard: /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/, // 身份证号
    // RegistrationCode: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/, // 统一社会信用代码
    RegistrationCode: /^[A-Za-z0-9]{0,30}$/, // 统一社会信用代码
    CodeNumber: /^[0-9]\d*|0$/ // 验证数字
  }
}
